interface IPreventNaNProps {
    children: number;
}

const PreventNaN = ({ children }: IPreventNaNProps) => {
    return (
        <>
            { isNaN(children) ? 0 : children }
        </>
    )
}

export default PreventNaN;
